import API from '..';
const ENTITY = 'annexes';

export const bulkAttachmentStatus = (data) =>
    API.put(
        `/api/v1/${ENTITY}/bulk-status/`,
        { ...data },
        { headers: { 'Content-Type': 'application/json' } },
    );

export const createAttachment = (data) => API.post(`/api/v1/${ENTITY}/`, data);

export const filterAttachments = ({
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
    status = 'active',
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            order_by: orderBy,
            page: page,
            per_page: perPage,
            ...(searchText ? { search: searchText } : {}),
            sort: sortBy,
            status_flag: status,
        },
    });
export const updateAttachment = (data, id) =>
    API.patch(`/api/v1/${ENTITY}/${id}/`, data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

export const updateAttachmentFile = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}/`, data);
